import { ROLE } from '../../constants';
import type { QaCategory } from '../../types/qa';

export const qaCategories: QaCategory[] = [
  {
    id: 'qaLogin',
    name: {
      ja: 'ログインで困ったら',
      en: 'Login',
    },
    collapsed: true,
    contentsFor: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    id: 'qaId',
    name: {
      ja: 'ユーザID/パスワードについて',
      en: '',
    },
    collapsed: true,
    contentsFor: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    id: 'qaAccount',
    name: {
      ja: 'アカウントについて',
      en: 'Account',
    },
    collapsed: true,
    contentsFor: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    id: 'qaApplication',
    name: {
      ja: '利用申請で困ったら',
      en: 'Application for use',
    },
    collapsed: true,
    contentsFor: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    id: 'qaInfo',
    name: {
      ja: 'お知らせ・通知メールについて',
      en: 'Notification',
    },
    collapsed: true,
    contentsFor: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    id: 'qaTimss',
    name: {
      ja: 'Timssについて',
      en: 'Mill sheet data',
    },
    collapsed: true,
    contentsFor: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    id: 'qaRegistration',
    name: {
      ja: '管理情報について',
      en: '',
    },
    collapsed: true,
    contentsFor: [ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
];
